import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { staticDataTypeQueries } from '@/services/staticDataType/staticDataType.queries';
import { useSearch } from '@tanstack/react-router';

export const useStaticDataTypeList = () => {
  const { page, fetch, q, sort } = useSearch({ from: '/(app)/logs-management/static-data-type/' });
  const { data, isLoading } = useQuery({
    ...staticDataTypeQueries.list({
      row: page,
      fetch: fetch,
      search: q,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data ?? [], sort),
    }),
  });
  return {
    staticDataType: data?.data || [],
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
